export default "__VITE_ASSET__DHyebGM$__"